var _effectorFileName = "/builds/gmini/front-sm-api-sdk/src/AnonymousClassifier/AnonymousClassifier.ts";
import * as t from 'io-ts';
import { Id } from '../Id';
import { Version } from '../Version';
import { BaseClassifier } from '../BaseClassifierRepo';
import { createPredicate } from '../createPredicate';
import { UserClassifier } from '../UserClassifierRepo/UserClassifier';
import { AssemblyClassifier } from '../UserClassifierRepo';
import { Urn } from '../Urn';
export var AnonymousClassifier;

(function (_AnonymousClassifier) {
  var type = _AnonymousClassifier.type = 'AnonymousClassifier';
  var io = _AnonymousClassifier.io = t.recursion('AnonymousClassifier', function () {
    return t.type({
      type: t.literal('AnonymousClassifier'),
      id: Id,
      version: Version,
      parentFolderId: t.union([t["null"], Id]),
      sourceClassifiers: t.readonlyArray(t.union([BaseClassifier.io, UserClassifier.io, AnonymousClassifier.io, AssemblyClassifier.io])),
      readOnly: t["boolean"],
      name: t.string,
      total: t.number,
      owner: t.union([t["null"], t.string]),
      versionNameOwner: t.union([t["null"], t.string]),
      versionCreatedDate: t.string,
      versionName: t.union([t["null"], t.string]),
      componentId: Id,
      componentType: t.union([t.literal('Checkup'), t.literal('Estimation'), t.literal('FieldInspection')]),
      projectUrn: Urn
    });
  });
  var is = _AnonymousClassifier.is = createPredicate(type);
})(AnonymousClassifier || (AnonymousClassifier = {}));